import styled from 'styled-components';
import { Dropdown as SemanticDropdown } from 'semantic-ui-react';
import { Header, Loader as LoaderLayoutComponent } from '@playbookux/playbook-web-core';

export const Loader = styled(LoaderLayoutComponent).attrs(() => ({
  inline: false,
}))``;

export const Dropdown = styled(SemanticDropdown)`
  &&&.ui.dropdown {
    position: absolute;
    right: 45px;
    width: 320px;
    z-index: 10;
  }
`;

export const Message = styled(Header)`
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
`;
